import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  DestroyRef,
  Input,
  QueryList,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AccordionItem } from '@shared/models/accordion-item';
import { AccordionItemComponent } from '../accordion-item/accordion-item.component';

@Component({
  standalone: false,
  selector: 'gstar-accordion',
  templateUrl: './accordion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements AfterContentInit {
  @ContentChildren(AccordionItemComponent)
  queryList!: QueryList<AccordionItemComponent>;
  @Input() multiple: boolean = true;

  destroyRef = inject(DestroyRef);

  ngAfterContentInit(): void {
    if (!this.multiple) {
      if (this.queryList.length) {
        this.init(this.queryList);
      } else {
        this.queryList.changes
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((queryList: QueryList<AccordionItemComponent>) => {
            this.init(queryList);
          });
      }
    }
  }

  init(queryList: QueryList<AccordionItemComponent>): void {
    queryList.forEach((item: AccordionItemComponent) => {
      item.expandCollapse.subscribe((current: AccordionItem) => {
        this.collapseOthers(current);
      });
    });
  }

  collapseOthers({ id }: AccordionItem): void {
    //This is skiped for now since is not working propertly and the requeriment is allow multiple expanding accordions
    this.queryList.forEach(({ accordionItem }: AccordionItemComponent) => {
      if (accordionItem().id !== id && accordionItem().isExpanded) {
        const item = accordionItem();
        item.isExpanded = false;
        accordionItem.set(item);
        accordionItem().changed.next(item.isExpanded);
      }
    });
  }
}
